import { CTAButton } from 'component/button';
import { useDatastore } from 'util/datastore';
import { canGoBack } from 'util/navigate';
import { type TLabel, t } from 'util/stdtypes';

import { HttpError } from './http-error';

export function NotFound({ label }: { label?: TLabel }) {
    const datastore = useDatastore();
    const goBack = () => {
        datastore.goBack();
    };

    return (
        <HttpError
            code='404'
            cta={canGoBack() ? <CTAButton label={t('appError.goHome', 'Go Back')} onPress={goBack} /> : null}
            label={label ?? t('appError.page_not_found', 'The page you’re looking for does not exist.')}
        />
    );
}
